export default {
    path: '/siteregularProject',
    component: () => import(/* webpackChunkName: 'project' */'@/views/project/layout/index'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'myproject',
        component: () => import(/* webpackChunkName: 'myproject' */'@/views/project/index')
      },
      {
        path: '/siteregularProject/tools/paymentPlan',
        name: 'paymentPlan',
        component: () => import(/* webpackChunkName: 'phase' */'@/views/project/tools/paymentPlan')
      },
      {
        path: '/siteregularProject/tools/milestonePaymentInformation',
        name: 'milestonePaymentInformation',
        component: () => import(/* webpackChunkName: 'phase' */'@/views/project/tools/milestonePaymentInformation')
      },
      //中心库
      {
        path: '/siteregularProject/studyCenterRepository',
        name: 'studyCenterRepository',
        component: () => import(/* webpackChunkName: 'phase' */'@/views/project/studyCenterRepository/index')
      },
      // 里程碑模板
      {
        path: '/siteregularProject/milestone',
        name: 'prjMilestone',
        component: () => import(/* webpackChunkName: 'milestone' */'@/views/project/set/milestone/index')
      },
      {
        path: '/siteregularProject/milestone/setting',
        name: 'prjMilestoneSetting',
        component: () => import(/* webpackChunkName: 'milestoneSetting' */'@/views/project/set/milestone/setting')
      }
    ]
  }
